export default function downloadDataURI(dataURI, filename) {
  const link = document.createElement('a');
  link.href = dataURI;
  link.download = filename;
  link.click();
}
